export default "__VITE_ASSET__emf9jvnT__"